import { useState } from 'react';

export default function useToggleText(text, limit) {

    const [isExpanded, setIsExpanded] = useState(false);
    const toggle = () => setIsExpanded(!isExpanded);
    const canExpand = text && text.length > limit;
    const displayText = isExpanded || !canExpand
        ? text
        : `${text.slice(0, limit)}...`;

    return {
        displayText,
        isExpanded,
        toggle,
        canExpand
    };
}
